import React from "react";
import NullableValue from "../../../../../../../Utils/renderField/nullableValue";
import { RenderNumber } from "../../../../../../../Utils/renderField/renderReadField";

// Pallets de una fila del cierre en proceso a un corte anterior al último
// movimiento de bodega. Ese corte no admite reajustes, así que solo hay pacas
// que mostrar
export const PacasAlCorteTable = ({ lineas }) => (
    <div className="new-table-wrapper">
        <table className="table-striped">
            <thead>
                <tr>
                    <th>No. de pallet</th>
                    <th>Identificador físico</th>
                    <th>Pacas</th>
                </tr>
            </thead>
            <tbody>
                {lineas.length === 0 && (
                    <tr>
                        <td colSpan={3} className="text-center">
                            No hay pallets con existencia de este producto y
                            condición
                        </td>
                    </tr>
                )}
                {lineas.map((linea) => (
                    <tr key={linea.pallet_id}>
                        <td className="text-center text-nowrap">
                            {linea.numero}
                        </td>
                        <td className="text-center text-nowrap">
                            <NullableValue value={linea.identificador_fisico}>
                                {linea.identificador_fisico || ""}
                            </NullableValue>
                        </td>
                        <td className="text-center text-nowrap">
                            <RenderNumber
                                value={linea.pacas_al_corte}
                                decimalScale={0}
                            />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
);
